import AdminNavbar from "@/components/AdminNavbar/AdminNavbar";
import { Button } from "@/components/ui/button";
import { RegularAssessment } from "@/schema/console/regular-assessments/RegularAssessment";
import CreateTestButton from "@/src/console/(auth)/(manage-assessments)/regular-assessments/_components/CreateTestButton";
import { format } from "date-fns";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

interface HeadingProps {
  draftTest?: RegularAssessment;
  currentActiveTest?: RegularAssessment;
}

function Heading({ draftTest, currentActiveTest }: HeadingProps) {
  const { t } = useTranslation();
  const breadcrumbs = [
    {
      name: "Regular assessment",
      href: "/console/regular-assessment",
    },
  ];
  const hasDraft = !!draftTest;
  const navigate = useNavigate();

  return (
    <div>
      <AdminNavbar breadcrumbs={breadcrumbs} />
      <div className="mx-6 my-8 flex justify-between">
        <div className="my-heading">{t("regular-assessment")}</div>
        {hasDraft ? (
          <Button
            onClick={() =>
              navigate(`/console/regular-assessments/create?duplicate=true`)
            }
          >
            {t("continue-editing-draft")}
          </Button>
        ) : (
          <CreateTestButton currentActiveTest={currentActiveTest} />
        )}
      </div>
      {hasDraft && (
        <div className="my-card mx-6 my-8 p-5">
          <div className="font-medium text-cool-gray-900">
            {t("regular-assessment-draft")}
          </div>
          <div className="text-cool-gray-600">
            {t("last-edited")}{" "}
            {format(new Date(draftTest.created_at), t("date-time-format"))}{" "}
            {t("by")} {draftTest.created_by.name}
          </div>
        </div>
      )}
    </div>
  );
}

export default Heading;
